<template>
  <v-main>
    <PageWrapper class="pa-0">
      <PageContent>
        <Alert/>
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
import Alert from '@/components/template/snackbar-home/Alert.vue';
import { mapGetters, mapActions } from 'vuex';

  export default {
    components:{
    PageWrapper,
    Alert,
    PageContent,
  },
    data: () => ({
      search:'',
      snackbar: true,
      dialogRecibo:false,
      dialogEdit:false,
      dialogDelete: false,
      loading:false,
      objEdit:{},
      editedIndex: -1,
    }),
    computed: {
      ...mapGetters('boleto',['getList']),
    },
    async created () {
       await this.getAllBoletos ( )
    },
    methods: {
      ...mapActions('boleto', ['getAllBoletos']),
      initialize () {
        this.boletos = ['']
      },
      deleteItem (item) {
        this.objEdit = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.getList.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      editItem (item) {
          this.objEdit = Object.assign({}, item)
          this.dialogEdit = true
        },
      closeDelete () {
         this.dialogDelete = false;
      },
      closeEditItem () {
         this.dialogEdit = false;
      },
      closeModal () {
        this.openDialog = false;
      },
      closeModalRecibo () {
        this.dialogRecibo = false;
      },
      close () {
        this.dialog = true
      }
    }
  }
</script>

<style>

.menu {
  width: 80%;
  padding-top: 70px;
  position: absolute;
}
.btn-new{
  margin-right: 24px;
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #272727;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
.btn-new-error {
  margin-right: 10px;
}

@media (max-width: 500px)
{
.btn-new{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 0px;
  padding: 10px;
  }
.btn-new-error {
  width: 100%;
}
.btn-pdf{
  display: flex;
  width: 100%;
}
}
</style>